export default __webpack_public_path__ + "static/media/calculator.182dc657.svg";